import React from 'react'
import PropTypes from 'prop-types'
//import './style.css'
import {NRTCourseTrailModule} from "./CourseTrailModule"

const NRTCourseTrail = (props) => {

    const {modules, userTracks, cantAccessModuleCodes = []} = props

    if (!modules)
        return null

    const hasTracks = !!userTracks && userTracks.length > 0

    // Faz uma copia do array de tracks para nao impactar no objeto original
    const tracks = hasTracks ? userTracks.slice(0) : []

    // const inProgressContents = hasTracks ? tracks.filter(track => track.status === 1 && !!track.contentDTO).map(track => track.contentDTO) : []
    // const concludedContents = hasTracks ? tracks.filter(track => track.status === 2 && !!track.contentDTO).map(track => track.contentDTO) : []
    // const currentContent = hasTracks ? tracks.filter(track => !!track.contentCode).sort(track => track.startDate).reverse().pop() : []
    
    let inProgressContents = []
    let concludedContents = []
    let currentContent = []

    modules.forEach(moduleDTO => {

        if(!!moduleDTO.classDTOs && moduleDTO.classDTOs.length > 0){
            moduleDTO.classDTOs.forEach(classDTO => {

                if(!!classDTO.contentDTOs && classDTO.contentDTOs.length > 0){

                    classDTO.contentDTOs.forEach(contentDTO => {
                        let t = tracks.filter(track => !!track.contentCode && track.contentCode === contentDTO.code).sort(track => track.startDate).reverse().pop()
                        
                        if(!!t && t.status === 2){
                            concludedContents.push(contentDTO)
                        }

                        if(!!t && t.status === 1){
                            inProgressContents.push(contentDTO)
                        }
                    })
                }
            })
        }
    })
    
    const activeContentId = props.activeContentId || currentContent.code

    return (
        props.modules
            .sort((a, b) => a.numOrder - b.numOrder)
            .map(module => {

                return (
                    <NRTCourseTrailModule
                        key={module.code}
                        module={module}
                        activeContentId={activeContentId}
                        concludedContents={concludedContents}
                        inProgressContents={inProgressContents}
                        onContentClick={props.onContentClick}
                        blocked={cantAccessModuleCodes.some((blockedCode)=> blockedCode === module.code )}
                    />
                )
            })

    )
}

NRTCourseTrail.propTypes = {
    activeContentId: PropTypes.number,
    onContentClick: PropTypes.func,
    modules: PropTypes.array.isRequired,
    userTracks: PropTypes.array.isRequired,

}

NRTCourseTrail.defaultProps = {}

export default NRTCourseTrail



// WEBPACK FOOTER //
// ./src/components/_ead/CourseTrail/index.js